<template>
  <div>
    <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <!-- Chamadas ativas -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Seleções ativas"
            type="gradient-green"
            :sub-title="String(stats.regularCount)"
            icon="ni ni-planet"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">
                de um total de
                <span class="font-weight-bold text-warning">
                  {{ stats.totalCount }} seleções ao total
                </span>
              </span>
            </template>
          </stats-card>
        </div>
        <!-- Total inscrições -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Inscrições totais"
            type="gradient-dark"
            :sub-title="String(stats.subscriptionsCount)"
            icon="fas fa-users"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">recebidas em todas as chamadas</span>
            </template>
          </stats-card>
        </div>
        <!-- Média inscrições -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Inscrições em média"
            type="gradient-primary"
            :sub-title="String(stats.subscriptionsAvg)"
            icon="fas fa-users"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">recebidas por seleção</span>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div
            class="card shadow table-container vld-parent"
            ref="selecoes_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Processos de seleção</h3>
                </div>
                <div class="col text-right">
                  <router-link :to="`/admin/selecoes/nova`">
                    <base-button type="primary" size="sm" :custom="true"
                      ><i class="fas fa-plus mr-1"></i> Cadastrar nova
                      seleção</base-button
                    >
                  </router-link>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="tableData"
              >
                <template slot="columns">
                  <th>Título</th>
                  <th>Página de inscrição</th>
                  <th>Data ínicio</th>
                  <th>Data fim</th>
                  <th>Inscrições</th>
                  <th>Status</th>
                  <th>Ações</th>
                </template>

                <template slot-scope="{ row }">
                  <th scope="row">
                    <div class="media align-items-center">
                      <i class="ni ni-tag mr-3 text-red"> </i>
                      <div class="media-body">
                        <span class="name mb-0 text-sm">
                          <router-link
                            :to="`/admin/selecoes/${row.id}/editar`"
                            class="btn btn-link pl-0"
                          >
                            {{ row.title }}
                          </router-link>
                        </span>
                      </div>
                    </div>
                  </th>
                  <td>
                    <a :href="row.link" target="_blank">Abrir link</a>
                    <base-button
                      size="sm"
                      type="link"
                      class="text-default"
                      :btn-icon-only="true"
                      icon="far fa-copy"
                      title="Copiar link da página de inscrição."
                      @click="copyLink(row.link)"
                    />
                  </td>
                  <td>
                    {{ row.start_date }}
                  </td>
                  <td>
                    {{ row.end_date }}
                  </td>
                  <td>
                    <span class="bg-white border rounded py-2 px-3"
                      >{{ row.subscriptions_count }}
                      <i class="fas fa-users ml-1 text-default"></i
                    ></span>
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      <span v-if="row.end_date">
                        <span class="completion mr-2"
                          >{{ row.completion }}%</span
                        >
                        <div>
                          <base-progress
                            :type="row.statusInfo.type"
                            :show-percentage="false"
                            class="pt-0"
                            :value="row.completion"
                          />
                        </div>
                      </span>
                      <span v-else>Fluxo contínuo - </span>
                      <span class="ml-2" :title="row.statusInfo.description">{{
                        row.statusInfo.name
                      }}</span>
                    </div>
                    <div v-if="row.remaining && row.completion > 0">
                      <span>Chamada encerra em {{ row.remaining }} dias</span>
                    </div>
                    <div v-else-if="row.missing">
                      <span>Chamada inicia em {{ row.missing }} dias</span>
                    </div>
                  </td>
                  <td>
                    <router-link
                      :to="'/admin/selecoes/' + row.id + '/editar'"
                      class="btn btn-white py-1 px-2"
                      title="Editar chamada"
                      ><i class="fas fa-edit text-info"></i
                    ></router-link>
                    <router-link
                      :to="'/admin/selecoes/' + row.id + '/inscricoes'"
                      class="btn btn-white py-1 px-2"
                      title="Gerenciar inscrições"
                      ><i class="fas fa-users"></i
                    ></router-link>
                  </td>
                </template>
              </base-table>
              <p v-if="empty" class="text-center text-warning mt-3">
                Nenhuma seleção cadastrada até o momento
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "selecoes-table",
  data() {
    return {
      tableData: [],
      empty: false,
      status: [
        {
          key: "open",
          value: "Regular",
          description:
            "Uma seleção regular fica visível e aceita novas inscrições.",
        },
        {
          key: "closed",
          value: "Encerrada",
          description:
            "Uma seleção encerrada não aceita inscrições. O status 'Encerrada' será exibido.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Uma selação invisível fica oculta e não aceita inscrições.",
        },
      ],
      stats: {
        totalCount: 0,
        regularCount: 0,
        subscriptionsCount: 0,
        subscriptionsAvg: 0,
      },
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.selecoes_table,
      width: 90,
      height: 90,
    });
    try {
      const origin = window.location.origin;
      const { data } = await api.get("/adm/recruitment-processes");
      data.forEach((process) => {
        const { remaining, total, missing } = this.getDiffInfo(
          process.start_date,
          process.end_date
        );
        process["remaining"] = remaining;
        process["missing"] = missing;
        process["completion"] = this.getCompletion(remaining, total);
        process["start_date"] = this.formatDate(process.start_date);
        process["end_date"] = this.formatDate(process.end_date);
        process["value"] = this.formatValue(process.value);
        process["statusInfo"] = this.getStatusInfo(
          process.status,
          process.completion
        );
        process.link = `${origin}/selecoes/${process.slug}/inscricao`;
      });
      if (data.length) {
        this.tableData = data;
      } else this.empty = true;
      this.calcStats();
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as seleções");
    }
  },
  methods: {
    getCompletion(remainingDays, totalDays) {
      if (remainingDays == 0) return 100;
      if (remainingDays > totalDays) return 0;
      if (totalDays > 0 && remainingDays > 0)
        return Math.round(Math.abs((1 - remainingDays / totalDays) * 100));
      return 0;
    },
    getDiffInfo(start, end) {
      const d1 = this.moment(start);
      const d2 = this.moment(end);
      const today = this.moment();
      let totalDays = d2.diff(d1, "days");
      let remainingDays = today.startOf("day").isAfter(d2, "day")
        ? 0
        : d2.diff(today, "days");
      let missingDays = d1.isAfter(today, "day") ? d1.diff(today, "days") : 0;
      return {
        remaining: remainingDays,
        total: totalDays,
        missing: missingDays,
      };
    },
    getStatusInfo(currentStatus, completion) {
      const selectedStatus = this.status.find(
        (status) => status.key === currentStatus
      );

      let statusInfo = {
        type: "info",
        name: selectedStatus.value,
        description: selectedStatus.description,
      };
      if (completion === 100) statusInfo.type = "success";
      else if (selectedStatus.key === "closed") statusInfo.type = "warning";
      if (selectedStatus.key === "hidden") statusInfo.type = "danger";
      return statusInfo;
    },
    calcStats() {
      const stats = this.stats;
      this.tableData.forEach((process) => {
        stats.totalCount++;
        if (process.status === "open") stats.regularCount++;
        if (process.subscriptions_count > 0)
          stats.subscriptionsCount += process.subscriptions_count;
      });
      if (stats.totalCount > 0) {
        stats.subscriptionsAvg = Math.round(
          stats.subscriptionsCount / stats.totalCount
        );
      }
    },
    copyLink(link) {
      try {
        let inputTest = document.createElement("input");
        inputTest.value = link;
        document.body.appendChild(inputTest); // append element in doc. body
        inputTest.select(); // select text
        document.execCommand("copy"); // copy to clipboard
        document.body.removeChild(inputTest); // remove element
        this.$toasted.show("Link da página de inscrição copiado com sucesso");
      } catch (e) {
        this.$toasted.error("Erro ao copiar link da página de inscrição");
      }
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
</style>
